<template>
    <main>
        <h1>Branding</h1>
        <p>On this page you will find the branding elements to be used as described in the corporate identity guidelines book.</p>

        <p><strong>Press</strong><br>Always contact us before using the logo: kommunikacio@ceh.hu</p>

        <h2>Colors</h2>
        <p>The sizes of the blocks give an indication of the dominance of the colors to be used in the identity.</p>
        <p>The secondary colors are support colors, they should not dominate the design.</p>
        <div class="color-palette">
            <span class="blue"></span>
            <span class="light-blue"></span>
            <span class="orange"></span>
            <span class="blue-b"></span>
            <span class="blue-c"></span>
            <span class="green"></span>
            <span class="yellow"></span>
            <span class="red"></span>
        </div>

        <div class="color-codes">
            <span />
            <strong>Primary</strong>
            <span />
            <span />
            <strong>Secondary</strong>
            <span />
            <span />
            <span />
            <span />
            <span />
            <span v-for="(color, key) in colors" :key="`key${key}`" class="color-fill" :class="key" />
            <span><strong>HEX</strong></span>
            <span v-for="color in colors" :key="`hex${color.hex}`">#{{ color.hex }}</span>
            <span><strong>RGB</strong></span>
            <span v-for="color in colors" :key="`rgb${color.rgb}`">{{ color.rgb }}</span>
            <span><strong>CMYK</strong></span>
            <span v-for="color in colors" :key="`cmyk${color.cmyk}`">{{ color.cmyk }}</span>
            <span><strong>PANTONE</strong></span>
            <span v-for="color in colors" :key="`pantone${color.pantone}`"><span v-show="color.pantone">PANTONE</span> {{ color.pantone }}</span>
        </div>

        <h3>Logo Magyar</h3>
        <section class="logos">
            <p>Full color</p>
            <img src="/img/logo/ceh-logo-hu-full-color.svg" alt="CÉH logo magyar">
            <span>
                <a download href="/img/logo/ceh-logo-hu-full-color.svg" target="_blank">download SVG</a>
                <a v-if="false" download href="/img/logo/ceh-logo-hu-full-color.eps" target="_blank">download EPS</a>
                <a download href="/img/logo/ceh-logo-hu-full-color.png" target="_blank">download PNG</a>
            </span>
            <p>White on blue/dark background</p>
            <img src="/img/logo/ceh-logo-hu-white-blue.svg" alt="CÉH logo magyar">
            <a download href="/img/logo/ceh-logo-hu-white-blue.svg" target="_blank">download SVG</a>
            <p>White transparent background</p>
            <img src="/img/logo/ceh-logo-hu-white.svg" alt="CÉH logo magyar">
            <a download href="/img/logo/ceh-logo-hu-white.svg" target="_blank">download SVG</a>
            <p>Black and White</p>
            <img src="/img/logo/ceh-logo-hu-black-white.svg" alt="CÉH logo magyar">
            <a download href="/img/logo/ceh-logo-hu-black-white.svg" target="_blank">download SVG</a>
        </section>

        <h3>Other languages</h3>
        <section class="logos">
            <p>Full color</p>
            <img src="/img/logo/ceh-logo-en-full-color.svg" alt="CÉH logo foreign">
            <span>
                <a download href="/img/logo/ceh-logo-en-full-color.svg" target="_blank">download SVG</a>
                <a v-if="false" download href="/img/logo/ceh-logo-en-full-color.eps" target="_blank">download EPS</a>
                <a download href="/img/logo/ceh-logo-en-full-color.png" target="_blank">download PNG</a>
            </span>
            <p>White on blue</p>
            <img src="/img/logo/ceh-logo-en-white-blue.svg" alt="CÉH logo foreign">
            <a download href="/img/logo/ceh-logo-en-white-blue.svg" target="_blank">download SVG</a>
            <p>White on transparent background</p>
            <img src="/img/logo/ceh-logo-en-white.svg" alt="CÉH logo foreign">
            <a download href="/img/logo/ceh-logo-en-white.svg" target="_blank">download SVG</a>
            <p>Black and White</p>
            <img src="/img/logo/ceh-logo-en-black-white.svg" alt="CÉH logo foreign">
            <a download href="/img/logo/ceh-logo-en-black-white.svg" target="_blank">download SVG</a>
        </section>

        <h3>Without payoff</h3>
        <section class="logos">
            <p>Full color</p>
            <img src="/img/logo/ceh-logo-full-color.svg" alt="CÉH logo without payoff">
            <a download href="/img/logo/ceh-logo-full-color.svg" target="_blank">download SVG</a>
            <p>White on blue</p>
            <img src="/img/logo/ceh-logo-white-blue.svg" alt="CÉH logo without payoff">
            <a download href="/img/logo/ceh-logo-white-blue.svg" target="_blank">download SVG</a>
            <p>White on transparent background</p>
            <img src="/img/logo/ceh-logo-white.svg" alt="CÉH logo without payoff">
            <a download href="/img/logo/ceh-logo-white.svg" target="_blank">download SVG</a>
            <p>Black and White</p>
            <img src="/img/logo/ceh-logo-black-white.svg" alt="CÉH logo without payoff">
            <a download href="/img/logo/ceh-logo-black-white.svg" target="_blank">download SVG</a>
        </section>

        <h2>Font</h2>
        <!--
        <h3>Nunito Sans</h3>
        <p><a href="https://fonts.google.com/specimen/Nunito+Sans">Nunito Sans</a> (Google Font)<br>
        Only use the <strong>300, 300i, 800 and 800i</strong> font weights.</p>
        <p class="nunito">
            The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.<br>
            <em>The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</em><br>
            <strong>The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</strong><br>
            <em><strong>The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</strong></em>
        </p>-->
        <h3>Arial</h3>
        <p><a href="https://docs.microsoft.com/en-us/typography/font-list/arial">Arial</a></p>
        <p class="arial">
            The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.<br>
            <em>The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</em><br>
            <strong>The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</strong><br>
            <em><strong>The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</strong></em>
        </p>
    </main>
</template>

<script>
    export default {
        data() {
            return {
                colors: {
                    "blue": { rgb: '36, 68, 115', cmyk: '95, 74, 28, 14', hex: '244473', pantone: '534 C'},
                    "light-blue": { rgb: '128, 206, 220', cmyk: '51, 0, 15, 0', hex: '80CEDC', pantone: '304 C'},
                    "orange": { rgb: '254, 165, 32', cmyk: '1, 41, 91, 0', hex: 'F5A520', pantone: '143 C'},
                    "blue-b": { rgb: '64, 106, 144', cmyk: '', hex: '406A90', pantone: ''},
                    "blue-c": { rgb: '94, 152, 178', cmyk: '', hex: '5E98B2', pantone: ''},
                    "green": { rgb: '139, 186, 116', cmyk: '', hex: '8BBA74', pantone: ''},
                    "yellow": { rgb: '248, 205, 96', cmyk: '', hex: 'F8CD60', pantone: ''},
                    "red": { rgb: '244, 95, 34', cmyk: '', hex: 'F45F22', pantone: ''}
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import '~$sass/_variables.scss';

    .nunito, .nunito * {
        font-family: 'Nunito Sans';
    }
    .arial, .arial * {
        font-family: Arial, Helvetica, sans-serif;
    }
    img {
        max-width: 200px;
    }

    h2 {
        margin-top: 80px;
        border-bottom: 1px solid lighten(#000, 95%);
    }

    h3 {
        margin-top: 20px;
    }

    .logos {
        grid-template-columns: 1fr 200px 130px;
        align-items: center;
        grid-gap: 50px;
        display: grid;
    }


    .color-palette {
        margin-bottom: 50px;
        min-height: 300px;
        grid-gap: 10px;
        display: grid;
        width: 600px;

        grid-template-areas:
            'blue blue blue blue blue light-blue light-blue light-blue blue-b'
            'blue blue blue blue blue light-blue light-blue light-blue blue-c'
            'blue blue blue blue blue light-blue light-blue light-blue green'
            'blue blue blue blue blue light-blue light-blue light-blue yellow'
            'blue blue blue blue blue orange orange orange red'
        ;

        .blue {
            grid-area: blue;
            background-color: $blue;
        }
        .light-blue {
            grid-area: light-blue;
            background-color: $light-blue;
        }
        .orange {
            grid-area: orange;
            background-color: $orange;
        }
        .blue-b {
            grid-area: blue-b;
            background-color: $branding-blue-b;
        }
        .blue-c {
            grid-area: blue-c;
            background-color: $branding-blue-c;
        }
        .green {
            grid-area: green;
            background-color: $branding-green;
        }
        .yellow {
            grid-area: yellow;
            background-color: $branding-yellow;
        }
        .red {
            grid-area: red;
            background-color: $branding-red;
        }
    }

    .color-codes {
        flex-direction: column;
        margin-bottom: 50px;
        flex-wrap: wrap;
        display: flex;
        height: 300px;

        > * {
            flex: 1 0 calc(100% / 9);
        }

        .color-fill {
            height: 30px;
            width: 30px;
            border-bottom: 10px solid #fff;
        }

        .blue {
            grid-area: blue;
            background-color: $blue;
        }

        .light-blue {
            background-color: $light-blue;
        }
        .orange {
            background-color: $orange;
        }
        .blue-b {
            background-color: $branding-blue-b;
        }
        .blue-c {
            background-color: $branding-blue-c;
        }
        .green {
            background-color: $branding-green;
        }
        .yellow {
            background-color: $branding-yellow;
        }
        .red {
            background-color: $branding-red;
        }
    }

</style>